import { Divider, Grid, Paper, Typography } from '@mui/material';
import { AppDispatch, RootStateType } from '@Store';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SBDropdown from '@Components/Dropdown';
import { useFormik } from 'formik';
import SbButton from '@Components/Button';
import { onForward } from './constants';
import * as Yup from 'yup';
import Loader from '@Components/Loader';
// import { downloadCarrierLabel } from '@Reducers/ShipmentHistory/actions';
import {
  PickupPincodeOptions,
  ProductIdsOptions,
} from '../../../ViewSingleShipmentAdmin/components/ShipmentProcessingV2/components/Nandan/constants';
import SbTextField from '@Components/Textfield';

// ------- VALIDATION SCHEMA -------
const nandanInformationSchema = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  pickup_pincode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Pickup pincode is required'),
  product_id: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Product ID is required'),
  con_no: Yup.string()
    .required('Consignment No. is required')
    .min(13, 'Consignment No. must be at least 13 characters'),
});

interface propsTypes {
  onClickForward: () => void;
  onClose?: () => void;
  initialStates: any;
  isEditable?: boolean;
  showFedExDetails: boolean;
  btnText: string;
}

const UserNandan = (props: propsTypes) => {
  const { onClickForward, onClose, initialStates, isEditable, showFedExDetails, btnText } = props;
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(false);
  const invoiceNo = useSelector((state: RootStateType) => state.shipment.shipmentById?._packageId.invoiceNumber);
  const { shipmentById, userNandanDetails: userNandanSettings } = useSelector((state: RootStateType) => state.shipment);
  // const { nandanDetails } = useSelector((state: RootStateType) => state.adminShipment);

  // ------------ FORMIK ------------
  const { values, setFieldValue, errors, handleSubmit } = useFormik<any>({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      ...initialStates,
      invoiceNumber: invoiceNo,
      accountNo: userNandanSettings?.accountNo?.length
        ? userNandanSettings?.accountNo.filter((acc: any) => acc.value.startsWith(initialStates.accountNo))
        : [],
    },
    validationSchema: nandanInformationSchema,
    onSubmit(values) {
      onForward({
        values,
        shipmentNumber: shipmentById?.shipmentNumber || '',
        dispatch,
        nextFunc: onClickForward,
        setLoading,
      });
    },
  });

  return (
    <>
      <Loader overly loading={loading}></Loader>
      {showFedExDetails && (
        <Paper
          variant="outlined"
          sx={{
            my: '2rem',
            p: '2rem',
          }}
        >
          <Grid container item xs={12}>
            <Grid container item mb={3}>
              <Grid item xs={12} md={6}>
                <Typography className="font-medium l-text pb-3">Nandan Information</Typography>{' '}
              </Grid>
            </Grid>
            <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="accountNo"
                    label="Nandan Account"
                    required
                    placeholder="Select"
                    name="accountNo"
                    value={
                      Array.isArray(values?.accountNo)
                        ? values.accountNo.map((item: { value: any }) => item.value)
                        : values.accountNo
                        ? [values.accountNo]
                        : []
                    }
                    options={userNandanSettings?.accountNo ?? []}
                    onChange={(_, selectedObj) => {
                      setFieldValue('accountNo', selectedObj);
                    }}
                    error={errors.accountNo as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="pickup_pincode"
                    label="Pickup Pincode"
                    required
                    placeholder="Select"
                    name="pickup_pincode"
                    value={values.pickup_pincode ? [values.pickup_pincode] : []}
                    options={
                      userNandanSettings?.pickup_pincode?.length
                        ? userNandanSettings.pickup_pincode
                        : PickupPincodeOptions
                    }
                    onChange={val => {
                      const selected = val[0] || '';
                      setFieldValue('pickup_pincode', selected);
                    }}
                    error={errors.pickup_pincode as string}
                  />
                </Grid>
              </Grid>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="product_id"
                    label="Service"
                    required
                    placeholder="Select"
                    name="product_id"
                    value={values.product_id ? [values.product_id] : []}
                    options={userNandanSettings?.product_id?.length ? userNandanSettings.product_id : ProductIdsOptions}
                    onChange={val => {
                      const selected = val[0] || '';
                      setFieldValue('product_id', selected);
                    }}
                    error={errors.product_id as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SbTextField
                    placeholder="Enter 13 digit AWB no."
                    label="Consignment No."
                    required
                    onChange={e => setFieldValue('con_no', e.target.value)}
                    name="con_no"
                    value={values.con_no}
                    error={errors.con_no as string}
                  />
                </Grid>
              </Grid>

              <Divider className="mt-3 mb-3" />
              <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
                <Grid container item sx={{ gap: '1rem' }}>
                  <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                    <SbButton
                      disabled={!isEditable}
                      variant="contained"
                      sx={{ borderRadius: '4px !important' }}
                      className="w-full"
                      onClick={_event => {
                        handleSubmit();
                      }}
                    >
                      {btnText}
                    </SbButton>
                  </Grid>
                  {onClose && (
                    <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                      <SbButton
                        sx={{ borderRadius: '4px !important' }}
                        className="w-full"
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </SbButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}
      {/* {nandanDetails?.response && (
        <Grid container item>
          <Grid item xs={'auto'} border={'1px solid'} className="border-grey font-medium md-text p-2" borderRadius={1}>
            This shipment has been forwarded.
            <Box
              component={'span'}
              className="font-medium md-text ml-1"
              sx={{
                color: '#485fc7',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (shipmentById?.shipmentNumber) {
                  dispatch(downloadCarrierLabel(shipmentById?.shipmentNumber));
                }
              }}
            >
              Download the carrier AWB
            </Box>
          </Grid>
        </Grid>
      )} */}
    </>
  );
};

export default UserNandan;
